<template>
<div></div>
</template>

<script>
export default {
  name: 'dummy',
}
</script>
